import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, signal, viewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { domain } from '../../../../environments/environment';
import { ProfileService } from '../profile.service';
import { BillingCardComponent, ITruevo } from '../components/billing-card/billing-card.component';
import { ConfirmPopup } from '../../../confirm.popup';
import { CardInputComponent } from "../../../card-input/card-input.component";

@Component({
  selector: 'profile-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BillingCardComponent, CardInputComponent]
})
export class ProfileBillingComponent {
  service = inject(ProfileService);
  activated = inject(ActivatedRoute);
  confirm = inject(ConfirmPopup);
  addcc = viewChild<ElementRef<HTMLAnchorElement>>('addcc');

  loading = signal<boolean>(false);

  cards: ITruevo[] = [];
  newCardUrl: string = `${domain}/addcc`;
  renewUrl: string = `${domain}/addccResub`;
  ccurl: string = this.newCardUrl;

  onCardAdded(payload: { _id?: string; membership?: string; transaction?: string; sync?: boolean }) {

    this.ccurl = payload?.membership ? this.renewUrl : this.newCardUrl;

    if (this.service.router.isFromApp()) {
      const element = this.addcc()?.nativeElement;
      if (element) {
        element.href = this.ccurl;
        element.click();
      }
    } else if (payload?.membership) {

      this.confirm.open('Resubscribe?', 'Payment method has been added. You currently have a cancelled membership, would you like to resubscribe it now?', 'Confirm Resubscription Prompt', [
        {
          label: 'No',
          paint: 'warn',
          close: true
        },
        {
          label: 'Yes',
          paint: 'primary',
          close: true,
          callback: () => {
            this.service.toggleSubscription(payload.membership!, true).subscribe({
              next: result => {
                this.service.profile.update(profile => {

                  if (profile?.membership) {
                    profile.membership.recurs = true;
                    profile.membership.next_package = undefined;
                  }

                  return Object.assign({}, profile);
                });

                this.service.toast.success(result.message);
              },
              error: error => {
                error = error.error || error;
                this.service.toast.error(error.message);
              }
            });
          }
        }
      ]);
    }

    if (payload?.sync) {
      this.service.auth.sync();
    }

  }

  getCards() {
    if (!this.loading()) {
      this.loading.set(true);
      this.service.getTruevos().subscribe({
        next: cards => {
          this.loading.set(false);
          this.cards = cards;
          // console.log(this.pay.cardCount);
        },
        error: error => {
          error = error.error || error;
          this.loading.set(false);
          this.service.toast.error(error.message);
        }
      });
    }
  }

  deleteCard(msg: string | null = null) {
    this.service.toast.error(msg || 'The selected card has been removed');
    this.getCards();
  }

}
